export const previousAppointmentData = {
  buttons: [
    {
      label: 'Yes I have',
      id: 'yes',
    },
    {
      label: "No I haven't",
      id: 'no',
    },
  ],
  title: 'Have you spoken to one of our experts about this issue previously?',
  imgObj: {
    alt: 'two people holding documents',
    src: 'https://media.product.which.co.uk/prod/images/original/8f95d1a7f0dc-cp-step9.jpg',
  },
}
